import FindParkingButton from 'components/bookings/find-parking-button';
import Brand from 'models/brand';

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  headline: PropTypes.string.isRequired,
  app: PropTypes.string.isRequired,
  trackEvent: PropTypes.func.isRequired,
};

const defaultProps = {
};

const AccountHeadline = ({ brand, headline, app, trackEvent }) => (
  <div className="row content-head hidden-lte-sm">
    <FindParkingButton brand={brand} app={app} trackEvent={trackEvent} />
    <div className="col-md-7 light-content-title">
      <h2 className="text-color-dark-slate margin-top-10 margin-bottom-0 text-size-20 text-weight-bold">
        {headline}
      </h2>
    </div>
  </div>
);

AccountHeadline.propTypes = propTypes;
AccountHeadline.defaultProps = defaultProps;
export default AccountHeadline;
